import { EasyPortal } from "../../Message/runtime";

export const PopoverArea = new EasyPortal("cn-popover").createArea();
